import { memo } from "react";
import widgetIcon from "/images/widget-icon.webp";
import closeIcon from "/images/close-icon.svg";
import { APP_NAME } from "@/configs/app";
interface ChatHeaderProps {
  onClose: () => void;
  agentState: string;
  isMicrophoneEnabled: boolean;
}

export const ChatHeader = memo(function ChatHeader({
  onClose,
  agentState,
  isMicrophoneEnabled,
}: ChatHeaderProps) {
  return (
    // padding: 0 0 10px 0 !important;
    <div className="nut-flex nut-items-center nut-justify-between nut-flex-shrink-0 nut-p-0 nut-mb-2">
      <div className="nut-flex nut-items-center nut-gap-[12px]">
        <div className="gradient-wrap nut-w-[40px] nut-h-[40px] nut-bg-white nut-rounded-[50%] nut-p-[1.72px]">
          <div className="content nut-flex nut-items-center nut-justify-center nut-cursor-pointer">
            <img
              src={widgetIcon}
              alt="widget-icon"
              className="nut-w-[21px] nut-h-[20px]"
            />
          </div>
        </div>
        <div>
          <p className="voice-chat_header-text nut-text-[16px] nut-leading-[130%]">
            {APP_NAME}
          </p>
          <p className="nut-text-[11px] nut-text-gray-500 nut-mt-[2px]">
            <span className="nut-inline-block nut-w-[6px] nut-h-[6px] nut-bg-[#38A169] nut-rounded-full nut-mr-[5px]" />
            Personal shopping assistant
          </p>
          <span
            style={{
              display: "none",
            }}
          >
            {agentState} / {isMicrophoneEnabled}
          </span>
        </div>
      </div>
      <a
        onClick={onClose}
        className="nut-w-[40px] nut-cursor-pointer nut-h-[40px] nut-rounded-[50%] nut-flex nut-items-center nut-justify-center nut-border-2 nut-border-[#D8D8D8]"
      >
        <img
          src={closeIcon}
          alt="close-icon"
          className="nut-w-[8.33px] nut-h-[8.33px]"
        />
      </a>
    </div>
  );
});
